import React from 'react';
import './Marker.css';
const marker_default = new URL('./graphics/marker--default.svg', import.meta.url);
import { Link } from "react-router";

const Marker = ({ path = '/', left = 50, top = 50}) => {

    // render html
    return(
        <Link to={path} className={`marker`} style={{left: `${left}%`, top: `${top}%`}}>
            <img src={marker_default} alt="Marker" />
        </Link>
    );
}

export default Marker;